import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-268" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-269" data-mp="3fxkxijk6olo7">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-270" data-mp="3b1cjj9hq2yim">Lo que dicen los que ya lo tienen</p>
        <h2 id="reviews-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-271" data-mp="370aj4pc2kgf2">
          Museos con contexto argentino
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-272" data-mp="2x004d0adz0xs">
          {reviews.map(([initials, name, role, quote, color], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-ivory flex min-h-[255px] flex-col rounded-2xl border border-line p-6 text-ink shadow-card" data-id="element-273" data-mp="2s39q8ii56ff0" data-mpi={index}>
              <div className="flex text-gold" data-id="element-274" data-mp="m2onyzsoo4nz">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-275" data-mp="c6vejpa9graf" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-muted" data-id="element-276" data-mp="zwpr05qo4du5">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-277" data-mp="14vsj6pljupkp">
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm font-extrabold text-white ${color}`} data-id="element-278" data-mp="q7650r7ns3v2">
                  {initials}
                </span>
                <span data-id="element-279" data-mp="1ivk131f6sq3z">
                  <b className="block text-sm text-ink" data-id="element-280" data-mp="1iu90fah1fyh3">{name}</b>
                  <small className="text-xs text-muted" data-id="element-281" data-mp="1nlqpp19p8am8">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}